module.exports = __webpack_public_path__ + "img/385-3181e0.png";